import { CEntity } from '@ts/ui-models';

export const normalizeCEntity = <T>(
  entity: { oldEntity: CEntity<T>; newEntity: CEntity<T> },
  attr: string,
  notify?: (message: string) => void,
  errory?: (value: boolean) => void
): CEntity<T> => {
  const { oldEntity, newEntity } = entity;
  if (attr === 'customId' && newEntity.customId) newEntity.setCustomId(newEntity.customId);

  return newEntity;
};
